export default class StickyElement {
    element: Element;
    parentElement: Element;
    timeout: Number;

    static create(selector: string) {
        let elements = document.querySelectorAll(selector);
        for (const element of elements) {
            new StickyElement(element);
        }
    }

    constructor(element: Element) {
        this.element = element;
        this.parentElement = element.parentElement;

        window.addEventListener('scroll', (event: Event) => {
            this.onScroll(event);
        });

        let resizeObserver = new ResizeObserver(() => {
            this.calculateElementPosition();
        });

        resizeObserver.observe(this.element);

        this.calculateElementPosition();
    }

    onScroll(event: Event) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            this.calculateElementPosition();
        }, 200);
    }

    calculateElementPosition() {
        const parentElementBBox = this.parentElement.getBoundingClientRect();
        const parentElementY = parentElementBBox.top;
        const elementBBox = this.element.getBoundingClientRect();

        if (elementBBox.height > parentElementBBox.height) {
            this.element.style = 'position: static';
            return true;
        }

        let deltaY = 0;

        if (parentElementY < 0) {
            deltaY = Math.abs(parentElementY);
        }

        let maximumDeltaY = parentElementBBox.height - elementBBox.height;

        if (deltaY > maximumDeltaY) {
            deltaY = maximumDeltaY;
        }

        this.element.style.top = deltaY + 'px';
    }

}
